<template>
    <footer class="footer  mt-auto py-3">
      <div class="container-fluid">
        <div class="d-flex justify-content-between">
          <div></div>
            <div class="d-none d-sm-block">
              <span class="text-white">© 2021 DiscoverLaos | Your Trusted Tourism Partner.</span>
            </div>
            <div>
              <div></div>
              <span class="m-2">
                    <a href="https://www.instagram.com/discoverlaostoday/" target="_blank">
                      <img src="@/assets/social/instagram.svg" alt="">
                    </a>
              </span>
              <span class="m-2"> 
                <a href="https://www.facebook.com/DiscoverLaosToday" target="_blank"> <img src="@/assets/social/fb.svg" alt=""></a>
                 
              </span>
              <span class="m-2"> 
                <a href="https://discoverlaos.today/" target="_blank">
                  <img src="@/assets/social/web.svg" alt="">
                  </a>
              </span>
              <span class="m-2">
                    <a href="https://www.youtube.com/c/discoverlaostoday" target="_blank">
                      <img src="@/assets/social/youtube.svg" alt="">
                    </a> 
              </span>
            </div>
        </div>
      </div>
    </footer>
</template>
<script>
export default {
    name:'FooterApp'
}
</script>